// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"870bbaa6","148":"defeb223","453":"38a80239","455":"ca8cc5ae","977":"e8b3ec01"}[chunkId] + ".chunk.js";
};